module.exports = __webpack_public_path__ + "img/orange_064.5994882a.png";